import { Typography } from '@mui/material';

export const AdhocInteraction = () => {
  return <Typography>This is adhoc interaction</Typography>;
};
